
import { LocaleMessageWithParams } from '@/commons/types'
import { FALLBACK_LOCALE } from '@/commons/constants/locale'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ENVIRONMENT } from '@/commons/configuration'

@Component
export default class BiometricRequirements extends Vue {
    @Prop() titleKey!: string
    @Prop({ default: false }) hasUrl!: boolean
    @Prop() requirements!: Array<LocaleMessageWithParams>

    get photoRequirementsUrl (): string {
        return ENVIRONMENT.photoRequirementsUrl[this.$i18n.locale || FALLBACK_LOCALE]
    }

    get ppaServicePointsUrl (): string {
        return ENVIRONMENT.ppaServicePointsUrl[this.$i18n.locale || FALLBACK_LOCALE]
    }
}
